import Vue from 'vue'
import Router from 'vue-router'
import { interopDefault } from './utils'
import scrollBehavior from './router.scrollBehavior.js'

const _1c4468ea = () => interopDefault(import('../pages/articles/index.vue' /* webpackChunkName: "pages/articles/index" */))
const _a9f30270 = () => interopDefault(import('../pages/banner-category/index.vue' /* webpackChunkName: "pages/banner-category/index" */))
const _eac3254e = () => interopDefault(import('../pages/banner-medias/index.vue' /* webpackChunkName: "pages/banner-medias/index" */))
const _6d43d7b8 = () => interopDefault(import('../pages/brand-page-settings/index.vue' /* webpackChunkName: "pages/brand-page-settings/index" */))
const _126ea239 = () => interopDefault(import('../pages/brands/index.vue' /* webpackChunkName: "pages/brands/index" */))
const _2b91413f = () => interopDefault(import('../pages/catalog-list/index.vue' /* webpackChunkName: "pages/catalog-list/index" */))
const _1edb86ae = () => interopDefault(import('../pages/certificates/index.vue' /* webpackChunkName: "pages/certificates/index" */))
const _f496adde = () => interopDefault(import('../pages/clients/index.vue' /* webpackChunkName: "pages/clients/index" */))
const _70347902 = () => interopDefault(import('../pages/deliveries/index.vue' /* webpackChunkName: "pages/deliveries/index" */))
const _20b6034a = () => interopDefault(import('../pages/discounts/index.vue' /* webpackChunkName: "pages/discounts/index" */))
const _10ba8d22 = () => interopDefault(import('../pages/login.vue' /* webpackChunkName: "pages/login" */))
const _3c519c66 = () => interopDefault(import('../pages/main-page-banners/index.vue' /* webpackChunkName: "pages/main-page-banners/index" */))
const _40bd1f40 = () => interopDefault(import('../pages/main-page-join-us/index.vue' /* webpackChunkName: "pages/main-page-join-us/index" */))
const _fa25455a = () => interopDefault(import('../pages/main-page-main-carousel/index.vue' /* webpackChunkName: "pages/main-page-main-carousel/index" */))
const _076ad200 = () => interopDefault(import('../pages/news/index.vue' /* webpackChunkName: "pages/news/index" */))
const _e32a51e6 = () => interopDefault(import('../pages/order-gifts/index.vue' /* webpackChunkName: "pages/order-gifts/index" */))
const _28fa39da = () => interopDefault(import('../pages/payments/index.vue' /* webpackChunkName: "pages/payments/index" */))
const _0005c5e8 = () => interopDefault(import('../pages/press/index.vue' /* webpackChunkName: "pages/press/index" */))
const _0b55599a = () => interopDefault(import('../pages/robots.vue' /* webpackChunkName: "pages/robots" */))
const _fa5b1c02 = () => interopDefault(import('../pages/subscriptions/index.vue' /* webpackChunkName: "pages/subscriptions/index" */))
const _77f2cbb6 = () => interopDefault(import('../pages/articles/edit/index.vue' /* webpackChunkName: "pages/articles/edit/index" */))
const _7c83a3c4 = () => interopDefault(import('../pages/catalog/category.vue' /* webpackChunkName: "pages/catalog/category" */))
const _57a22f9d = () => interopDefault(import('../pages/catalog/category-list.vue' /* webpackChunkName: "pages/catalog/category-list" */))
const _2cf2a8a6 = () => interopDefault(import('../pages/catalog/params.vue' /* webpackChunkName: "pages/catalog/params" */))
const _344ac0f8 = () => interopDefault(import('../pages/catalog/products.vue' /* webpackChunkName: "pages/catalog/products" */))
const _c7906c62 = () => interopDefault(import('../pages/news/edit/index.vue' /* webpackChunkName: "pages/news/edit/index" */))
const _536c1d8e = () => interopDefault(import('../pages/orders/list.vue' /* webpackChunkName: "pages/orders/list" */))
const _51c1a844 = () => interopDefault(import('../pages/orders/stat.vue' /* webpackChunkName: "pages/orders/stat" */))
const _8f76a250 = () => interopDefault(import('../pages/orders/view/index.vue' /* webpackChunkName: "pages/orders/view/index" */))
const _9ce75da2 = () => interopDefault(import('../pages/users/list.vue' /* webpackChunkName: "pages/users/list" */))
const _6c4ee1cd = () => interopDefault(import('../pages/articles/edit/_id.vue' /* webpackChunkName: "pages/articles/edit/_id" */))
const _798c3930 = () => interopDefault(import('../pages/articles/view/_id.vue' /* webpackChunkName: "pages/articles/view/_id" */))
const _5b7bf3f7 = () => interopDefault(import('../pages/news/edit/_id.vue' /* webpackChunkName: "pages/news/edit/_id" */))
const _c33ef180 = () => interopDefault(import('../pages/orders/view/_id.vue' /* webpackChunkName: "pages/orders/view/_id" */))
const _ad604500 = () => interopDefault(import('../pages/banner-category/_slug.vue' /* webpackChunkName: "pages/banner-category/_slug" */))
const _3f067df8 = () => interopDefault(import('../pages/main-page-join-us/_slug.vue' /* webpackChunkName: "pages/main-page-join-us/_slug" */))
const _fd9287ea = () => interopDefault(import('../pages/main-page-main-carousel/_slug.vue' /* webpackChunkName: "pages/main-page-main-carousel/_slug" */))
const _1c03718e = () => interopDefault(import('../pages/users/_id.vue' /* webpackChunkName: "pages/users/_id" */))
const _2dfb1658 = () => interopDefault(import('../pages/index.vue' /* webpackChunkName: "pages/index" */))

// TODO: remove in Nuxt 3
const emptyFn = () => {}
const originalPush = Router.prototype.push
Router.prototype.push = function push (location, onComplete = emptyFn, onAbort) {
  return originalPush.call(this, location, onComplete, onAbort)
}

Vue.use(Router)

export const routerOptions = {
  mode: 'history',
  base: decodeURI('/'),
  linkActiveClass: 'active',
  linkExactActiveClass: 'nuxt-link-exact-active',
  scrollBehavior,

  routes: [{
    path: "/articles",
    component: _1c4468ea,
    name: "articles"
  }, {
    path: "/banner-category",
    component: _a9f30270,
    name: "banner-category"
  }, {
    path: "/banner-medias",
    component: _eac3254e,
    name: "banner-medias"
  }, {
    path: "/brand-page-settings",
    component: _6d43d7b8,
    name: "brand-page-settings"
  }, {
    path: "/brands",
    component: _126ea239,
    name: "brands"
  }, {
    path: "/catalog-list",
    component: _2b91413f,
    name: "catalog-list"
  }, {
    path: "/certificates",
    component: _1edb86ae,
    name: "certificates"
  }, {
    path: "/clients",
    component: _f496adde,
    name: "clients"
  }, {
    path: "/deliveries",
    component: _70347902,
    name: "deliveries"
  }, {
    path: "/discounts",
    component: _20b6034a,
    name: "discounts"
  }, {
    path: "/login",
    component: _10ba8d22,
    name: "login"
  }, {
    path: "/main-page-banners",
    component: _3c519c66,
    name: "main-page-banners"
  }, {
    path: "/main-page-join-us",
    component: _40bd1f40,
    name: "main-page-join-us"
  }, {
    path: "/main-page-main-carousel",
    component: _fa25455a,
    name: "main-page-main-carousel"
  }, {
    path: "/news",
    component: _076ad200,
    name: "news"
  }, {
    path: "/order-gifts",
    component: _e32a51e6,
    name: "order-gifts"
  }, {
    path: "/payments",
    component: _28fa39da,
    name: "payments"
  }, {
    path: "/press",
    component: _0005c5e8,
    name: "press"
  }, {
    path: "/robots",
    component: _0b55599a,
    name: "robots"
  }, {
    path: "/subscriptions",
    component: _fa5b1c02,
    name: "subscriptions"
  }, {
    path: "/articles/edit",
    component: _77f2cbb6,
    name: "articles-edit"
  }, {
    path: "/catalog/category",
    component: _7c83a3c4,
    name: "catalog-category"
  }, {
    path: "/catalog/category-list",
    component: _57a22f9d,
    name: "catalog-category-list"
  }, {
    path: "/catalog/params",
    component: _2cf2a8a6,
    name: "catalog-params"
  }, {
    path: "/catalog/products",
    component: _344ac0f8,
    name: "catalog-products"
  }, {
    path: "/news/edit",
    component: _c7906c62,
    name: "news-edit"
  }, {
    path: "/orders/list",
    component: _536c1d8e,
    name: "orders-list"
  }, {
    path: "/orders/stat",
    component: _51c1a844,
    name: "orders-stat"
  }, {
    path: "/orders/view",
    component: _8f76a250,
    name: "orders-view"
  }, {
    path: "/users/list",
    component: _9ce75da2,
    name: "users-list"
  }, {
    path: "/articles/edit/:id",
    component: _6c4ee1cd,
    name: "articles-edit-id"
  }, {
    path: "/articles/view/:id?",
    component: _798c3930,
    name: "articles-view-id"
  }, {
    path: "/news/edit/:id",
    component: _5b7bf3f7,
    name: "news-edit-id"
  }, {
    path: "/orders/view/:id",
    component: _c33ef180,
    name: "orders-view-id"
  }, {
    path: "/banner-category/:slug?",
    component: _ad604500,
    name: "banner-category-slug"
  }, {
    path: "/main-page-join-us/:slug?",
    component: _3f067df8,
    name: "main-page-join-us-slug"
  }, {
    path: "/main-page-main-carousel/:slug?",
    component: _fd9287ea,
    name: "main-page-main-carousel-slug"
  }, {
    path: "/users/:id?",
    component: _1c03718e,
    name: "users-id"
  }, {
    path: "/",
    component: _2dfb1658,
    name: "index"
  }],

  fallback: false
}

export function createRouter () {
  return new Router(routerOptions)
}
